import { StatusPill, LocCell } from "@/components/network/StatusPill";
import { OldKodeLabel } from "@/components/network/OldKodeLabel";
import { SELECT_CLS } from "@/lib/network";

// Daftar kartu HP (< md) — urutan memakai state sort tabel desktop yang sama.
export function InfraCards({ prefix, st, cols, empty, render }) {
  const val = st.sort ? `${st.sort.col}:${st.sort.dir}` : "";
  return (
    <div className="space-y-2 md:hidden" data-testid={`${prefix}-cards`}>
      <select className={`${SELECT_CLS} w-full`} value={val} data-testid={`${prefix}-cards-sort`}
              onChange={(e) => { const [col, dir] = e.target.value.split(":"); st.setSort(col ? { col, dir } : null); }}>
        <option value="">Urutan default</option>
        {cols.flatMap(([c, l]) => [<option key={`${c}a`} value={`${c}:asc`}>{l} ↑</option>, <option key={`${c}d`} value={`${c}:desc`}>{l} ↓</option>])}
      </select>
      {(st.sorted || []).map(render)}
      {empty && <p className="rounded-lg border border-[#E5E7EB] bg-white p-6 text-center text-sm text-[#6B7280]" data-testid={`${prefix}-cards-empty`}>{empty}</p>}
    </div>
  );
}

export function InfraCard({ prefix, row, q, sub, info, actions }) {
  const k = row.kode;
  return (
    <div className="rounded-lg border border-[#E5E7EB] bg-white p-3" data-testid={`${prefix}-card-${k}`}>
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="break-all font-mono-tab text-sm font-semibold">{k}<OldKodeLabel row={row} q={q} testid={`${prefix}-card-oldkode-${k}`} />
            {row.archived && <span className="ml-1 rounded bg-[#E5E7EB] px-1 text-[10px] font-semibold text-[#374151]" data-testid={`${prefix}-card-archived-${k}`}>ARSIP</span>}</div>
          {row.nama && <div className="break-words text-xs text-[#374151]">{row.nama}</div>}
          <div className="break-words text-xs text-[#6B7280]">{sub}</div>
          {(row.in_server || row.has_coords === false) && <div className="mt-1"><LocCell row={row} testid={`${prefix}-card-nocoord-${k}`} /></div>}
        </div>
        <StatusPill status={row.status} />
      </div>
      <div className="mt-2 flex flex-wrap items-end justify-between gap-2">
        <div className="min-w-0 break-words text-xs text-[#374151]" data-testid={`${prefix}-card-info-${k}`}>{info}</div>
        <div className="flex shrink-0 items-center">{actions}</div>
      </div>
    </div>
  );
}
